import { createSelector } from '@opengov/compose-app/reselect';

import { userSelector } from './actionsAndReducer';

export const selectUsers = createSelector(
  userSelector,
  state => {
    return state.users;
  }
);
